module.exports = __webpack_public_path__ + "img/3_Dicks_Screen_L_2_L.cf9e2625.jpg";